import {clsx} from 'clsx';
import {isContainerQueryAvailable} from '../lib/container-query-with-fallback';
import styles from './company-name.module.css';

type Props = {
  readonly companyName: string;
  readonly companyId: number;
};

export function CompanyInformationCompanyName({companyName, companyId}: Props) {
  return (
    <a
      href={`/main/html/searchrlp/company_id/${companyId}`}
      className={clsx(
        styles.companyName,
        isContainerQueryAvailable() ? styles.pressReleaseRoot : styles.screen,
      )}
    >
      {companyName}
    </a>
  );
}
